<template>
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
        <b-nav-item-dropdown class="d-block" menu-class="dropdown-menu-media pb-0 pt-0" right>
            <template #button-content>
                <span class="text-dark">
                    <feather-icon :icon="loadingStatus ? 'LoaderIcon' : 'BellIcon'" size="21" :badge="boardNewDocumentCount" badge-classes="badge-danger" />
                </span>

                <template v-for="(item, itemIdx) in isInformList">
                    <board-modal :key=itemIdx :document=item></board-modal>
                </template>
            </template>

            <!-- Header -->
            <li class="dropdown-menu-header">
                <div class="dropdown-header d-flex cusotm-css">
                    <h4 class="notification-title mb-0">{{ $t('org.common.Notice') }}</h4>
                    <b-badge pill variant="light-warning">{{ boardDocuments.length }}</b-badge>
                </div>
            </li>
            <!-- Notifications -->
            <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="scrollable-container media-list scroll-area" tagname="li">
                <template v-if="boardDocuments.length > 0">
                    <b-dropdown-item v-for="(item, index) in boardDocuments" :key="index" :to="`/notices/${item.service}/${item.timestamp}`">
                        <div class="custom-css">
                            <b-avatar variant="light-primary" :badge="checkOfWeek(item.timestamp) < 7" class="mr-1" badge-top badge-variant="danger">
                                <feather-icon icon="MessageSquareIcon" />
                            </b-avatar>
                            <p class="media-heading" style="vertical-align:middle;max-width:230px;overflow:hidden;text-overflow:ellipsis">
                                <span class="font-weight-bolder">{{ item.subject }}</span>
                            </p>
                            <small class="notification-text" style="float:right;line-height:2.8">{{ new Date(item.timestamp * 1).toLocaleDateString() }}</small>
                        </div>
                    </b-dropdown-item>
                </template>
                <template v-else>
                    <b-media class="custom-css">
                        <p class="media-heading text-center">
                            <span class="font-weight-bolder">{{ $t('org.message.There is no notice') }}</span>
                        </p>
                    </b-media>
                </template>
            </vue-perfect-scrollbar>
            <!-- Footer -->
            <li>
                <hr class="m-0">
            </li>
            <b-dropdown-item :to="{ name: 'notices' }" class="text-center" variant:='primary'>
                Read all notice
            </b-dropdown-item>
        </b-nav-item-dropdown>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import { getCurrentInstance, computed } from '@vue/composition-api'
import BoardModal from './IsInformBoardModal'
export default {
    components: {
        VuePerfectScrollbar,
        BoardModal
    },
    directives: {
        Ripple
    },
    props: {
        loadingStatus: Boolean
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        /* data */
        const perfectScrollbarSettings = {
            maxScrollbarLength: 60,
            wheelPropagation: false
        }

        /* computed */
        const boardDocuments = computed(() => store.getters.boardDocuments)
        const boardNewDocumentCount = computed(() => {
            let newCount = 0
            boardDocuments.value.filter(item => {
                // 7일간 Badge 유지
                if (checkOfWeek(item.timestamp) < 7) newCount++
            })
            return newCount
        })

        const year = new Date().getFullYear()
        const month = new Date().getMonth()
        const day = new Date().getDate()
        const today = new Date(year, month, day).getTime()
        const isInformList = computed(() => {
            // console.log(new Date('2025', '00', '03').getTime()) // 2025-01-03
            return store.getters.boardDocuments.filter(item => item.isInform && item.status === 'active').filter(item => {
                if (Object.keys(localStorage).includes('isInform-hide' + item.timestamp)) {
                    if (today > JSON.parse(localStorage.getItem('isInform-hide' + item.timestamp))) {
                        localStorage.removeItem('isInform-hide' + item.timestamp)
                        return item
                    }
                } else {
                    return item
                }
            })
        })

        /* methods */
        const checkOfWeek = (timestamp) => {
            return (new Date().getTime() - timestamp) / 1000 / 60 / 60 / 24
        }

        return {
            perfectScrollbarSettings,
            boardDocuments,
            boardNewDocumentCount,
            checkOfWeek,
            isInformList
        }
    }
}
</script>

<style>
.cusotm-css.dropdown-header {
    padding: 1.3rem
}
.custom-css .media-heading {
    color: #d0d2d6;
    margin-bottom: 0;
    margin-left: 1rem;
    display: inline-block;
    max-width: 150px;
    white-space:nowrap;
}
body:not(.dark-layout) .custom-css .media-heading {
    color: #6e6b7b;
}

/* [dir] .dark-layout .custom-css.media:hover {
    background-color: #161d31 !important;
    cursor: inherit
} */
</style>
